import Authentication from "./Authentication"
import { SalesPage } from "./Marketing/SalesPage"
import PortPredictor from "./PortPredictor"
import Prevetting from "./Prevetting"
import Reports from "./Reports"
import Version from "./Version"
import PoolPortal from "./PoolPortal"
import MaintenanceNotification from "./Admin/MaintenanceNotification"
import Sidebar from "./Admin/Sidebar"
import PortHolidaysUpload from "./PortHolidays"
import VesselTracking from "./VesselTracking"
import PortPredictorBacktest from "./PortPredictorBacktest"
import SeaMargin from "./Admin/SeaMargin"

const routes = [
  // ...Dashboard.routes,
  ...Authentication.routes,
  ...Reports.routes,
  ...Prevetting.routes,
  ...PortPredictor.routes,
  ...Version.routes,
  ...PoolPortal.routes,
  ...MaintenanceNotification.routes,
  ...Sidebar.routes,
  ...SeaMargin.routes,
  ...PortHolidaysUpload.routes,
  ...VesselTracking.routes,
  ...PortPredictorBacktest.routes,
  {
    path: "/freight-optimizer",
    permissionForPage: "read:freight-optimizer",
    component: () => <SalesPage />,
  },
  {
    path: "/chartering-insights",
    permissionForPage: "read:chartering-insights",
    component: () => <SalesPage />,
  },

  // ...ChartDesigns.routes,
  // ...PageDesigns.routes,
  // ...UIElements.routes,
  // ...FormDesigns.routes,
]

export { routes }
